<template>
  <div class="container">
    <div class="ban-box">
      <van-image
        src="https://files.alighting.com/Cover/special_20220524.png"
        class="bg"
        fit="contain"
      ></van-image>
      <div class="ban_ul">
        <div>首页</div>
        <div @click="toLink(1)">品牌连线</div>
        <div @click="toLink(2)">品牌新品推荐</div>
        <!-- <div @click="toLink(3)">品牌直播</div> -->
      </div>
    </div>
    <!-- 动态 -->
    <div class="trends-box">
      <van-notice-bar
        v-if="operateList[0].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[0]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>新品点评官{{ item.CompanyName }}{{ item.Duty }}</span>
          </div>
        </div>
      </van-notice-bar>
      <van-notice-bar
        v-if="operateList[1].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[1]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>新品点评官{{ item.CompanyName }}{{ item.Duty }}</span>
          </div>
        </div>
      </van-notice-bar>
    </div>
    <!-- 品牌连线 -->
    <div class="online-box">
      <div class="top-box">
        <div class="title">品牌连线</div>
        <div class="common exTitle">Brand connection</div>
        <div class="sTitle">
          8大细分应用领域共同对话、共同探讨照明趋势、技术
        </div>
      </div>
      <van-image
        src="https://files.alighting.com/Cover/special_02_20220517.jpg"
        fit="cover"
        style="width: 100%; height: 650rpx"
      ></van-image>
    </div>
    <!-- 品牌互动 -->
    <div
      class="online-box"
      style="background: linear-gradient(90deg, #3b3da1, #031b61)"
    >
      <div class="top-box">
        <div class="title" style="color: #fff">品牌互动</div>
        <div class="common interTitle">Brand interaction</div>
        <div class="sTitle" style="color: #fff">
          走进产业标杆企业，深入企业内部，解锁最新产品技术
        </div>
      </div>
      <div class="big-box">
        <div class="list-box">
          <div class="item-box" v-for="(item, index) in list" :key="index">
            <div class="companyInfo">
              <van-image
                :src="item.Logo"
                class="logoImg"
                fit="cover"
              ></van-image>
              <div class="name">{{ item.CompanyName }}</div>
            </div>
            <div class="desc">{{ item.Introduction }}</div>
            <div class="picBox">
              <van-image
                :src="item.ProductList[0].Photos[0]"
                fit="contain"
              ></van-image>
            </div>
            <div class="pTitle">{{ item.ProductList[0].Title }}</div>
            <mini-program
              class="liveBtn"
              v-if="item.LiveId != 0"
              :path="
                '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
              "
            >
              预约该企业直播
            </mini-program>
          </div>
        </div>
        <div class="openItem" v-if="isAll == 0" @click.stop="showMoreHandle">
          <span>展开更多</span>
          <span class="iconfont icon-arrow-down"></span>
        </div>
        <div class="openItem" v-else @click.stop="closeMoreHandle">
          <span>收起</span>
          <span class="iconfont icon-arrow-up"></span>
        </div>
      </div>
    </div>
    <!-- 品牌新品展示 -->
    <div class="show-box">
      <div class="top-box">
        <div class="title">品牌新品展示</div>
        <div class="common exTitle">new product display</div>
        <div class="sTitle" style="width: 300px; margin: 16px auto 0">
          300+品牌新品在线揭秘 1000位展会专业观众组成新品鉴赏官，在线点评
        </div>
      </div>
      <div class="imgList">
        <img
          src="https://files.alighting.com/special/show01.png"
          @click.stop="toTab(1)"
        />
        <img
          src="https://files.alighting.com/special/show02.png"
          @click.stop="toTab(2)"
        />
        <img
          src="https://files.alighting.com/special/show03.png"
          @click.stop="toTab(3)"
        />
        <img
          src="https://files.alighting.com/special/show04.png"
          @click.stop="toTab(5)"
        />
        <img
          src="https://files.alighting.com/special/show05.png"
          @click.stop="toTab(6)"
        />
        <img
          src="https://files.alighting.com/special/show06.png"
          @click.stop="toTab(4)"
        />
        <img
          src="https://files.alighting.com/special/show07.png"
          @click.stop="toTab(7)"
        />
        <img
          src="https://files.alighting.com/special/show08.png"
          @click.stop="toTab(8)"
        />
      </div>
    </div>
    <!-- 数字展厅 -->
    <div class="online-box">
      <div class="top-box">
        <div class="title">数字展厅</div>
        <div class="common exTitle">Digital exhibition hall</div>
        <div class="sTitle">近1000家全球知名展商生产全貌云展示</div>
      </div>
      <!-- 展区分布 -->
      <div class="distribution-box">
        <router-link to="/expoExhibitor">
          <img src="https://cdn.alighting.com/wxopen/cover/fenbu2026.jpg" class="fenbuImg" />
        </router-link>
        <div class="region">
          <div class="area"><span>A区展馆</span></div>
          <div class="exh_list">
            <div v-for="(item, index) in activeExhibitionListA" :key="index">
              <div class="el_item" @click="toShowRoom(item.HallNo)">
                <div>{{ item.HallNoDesc }}</div>
                <div class="overFlowTwo">{{ item.Desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="region region_b">
          <div class="area"><span>B区展馆</span></div>
          <div class="exh_list">
            <div v-for="(item, index) in activeExhibitionListB" :key="index">
              <div class="el_item" @click="toShowRoom(item.HallNo)">
                <div>{{ item.HallNoDesc }}</div>
                <div class="overFlowTwo">{{ item.Desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 参展商品牌展示 -->
    <div
      class="online-box"
      style="background-color: #f7f7f7; padding-bottom: 140rpx"
    >
      <div class="top-box">
        <div class="title">参展商品牌展示</div>
        <div class="common exTitle">Exhibitor brand display</div>
      </div>
      <div class="hotBox">
        <div class="tabBox">
          <div
            v-for="(bitem, bindex) in brandClassify"
            :key="bindex"
            class="tabItem"
            :class="bindex == bIndex ? 'active' : ''"
            @click.stop="tabHandle(bindex)"
          >
            {{ bitem.Name }}
          </div>
        </div>
        <div class="scrollBox" id="oneBox">
          <div
            class="scrollItem"
            v-for="(bitem, bindex) in brandList[0]"
            :key="bindex"
            @click="toStoreIndex(bitem.MemberID)"
          >
            <van-image
              fit="contain"
              :src="bitem.Photo"
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <div class="scrollName overFlowTwo">
              {{ bitem.CompanyNameChi }}
            </div>
          </div>
          <div style="margin-top: 6px">
            <div
              class="scrollItem"
              v-for="(bitem, bindex) in brandList[1]"
              :key="bindex"
              @click="toStoreIndex(bitem.MemberID)"
            >
              <van-image
                fit="contain"
                :src="bitem.Photo"
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              ></van-image>
              <div class="scrollName overFlowTwo">
                {{ bitem.CompanyNameChi }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="online-box">
      <div class="top-box">
        <div class="title">合作伙伴</div>
        <div class="common exTitle">partner</div>
      </div>
      <div class="company-box">
        <div>
          <div class="partner">主办单位</div>
          <div class="imgs">
            <img src="../../../static/images/live/cimg.png" />
            <img src="../../../static/images/live/cimg01.png" />
            <img src="../../../static/images/live/cimg02.png" />
          </div>
        </div>
        <div>
          <div class="partner">承办单位</div>
          <div class="imgs">
            <img src="../../../static/images/live/cimg03.png" />
          </div>
        </div>
        <div v-if="imgList.length > 0">
          <div class="partner">联合单位</div>
          <div class="imgs">
            <van-image
              fit="contain"
              v-for="(item, index) in imgList"
              :key="index"
              :src="item.Img"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="contact-box">
      <div class="cTitle">联系我们</div>
      <div class="ceTitle">contact</div>
      <div class="contactor-box">
        <div>
          <div class="contact-title">活动咨询</div>
          <img
            src="../../../static/images/live/cimg04.png"
            show-menu-by-longpress="true"
            class="contactorImg"
          />
          <div>联系人：尹女士</div>
          <div>电 话：+86 139 2649 9651</div>
          <div>邮 箱：yn@alighting.cn</div>
        </div>
        <div>
          <div class="contact-title">合作咨询</div>
          <img
            src="../../../static/images/live/cimg05.png"
            show-menu-by-longpress="true"
            class="contactorImg"
          />
          <div>联系人：邵 女士</div>
          <div>电 话：+86 139 2884 8289</div>
          <div>邮 箱：syl@alighting.cn</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NoticeBar, Image } from "vant";
import {
  exhActivityMemberLogsForHome,
  exhibitionBrandRecommendList,
  liveExhibitionCompanyList,
} from "@/api/online";
import { exhibitionList, mobileAdverts } from "@/api/index";
import miniProgram from "@/components/miniProgram";
export default {
  name: "onlineExhibitionTopics",
  components: {
    "van-notice-bar": NoticeBar,
    "van-image": Image,
    miniProgram,
  },
  data() {
    return {
      operateList: [[], []], //动态列表

      isAll: 0,
      list: [], //品牌互动
      allList: [],

      exhibitionList: [], //展馆列表

      bIndex: 0,
      brandClassify: [
        {
          Name: "全部",
          Arr: [],
        },
        {
          Name: "文旅景观",
          Arr: ["11", "21"],
        },
        {
          Name: "智慧城市",
          Arr: ["31", "51"],
        },
        {
          Name: "光源/灯具",
          Arr: ["42"],
        },
        {
          Name: "材料/设备",
          Arr: ["22", "41"],
        },
        {
          Name: "商用照明",
          Arr: ["112", "122"],
        },
        {
          Name: "光·智能",
          Arr: ["32", "92", "102", "132"],
        },
      ],
      brandList: [[], []],
      pageIndex: 1,
      total: 0,

      imgList: [], //合作伙伴
    };
  },
  computed: {
    activeExhibitionListA() {
      return this.exhibitionList.filter((item) => item.Region == 1);
    },
    activeExhibitionListB() {
      return this.exhibitionList.filter((item) => item.Region == 2);
    },
  },
  methods: {
    //底部tab跳转
    toLink(n) {
      if (n == 1) {
        this.$router.push({ path: "/brandLive" });
      } else if (n == 2) {
        this.$router.push({ path: "/newBrands", query: { type: 0 } });
      } else if (n == 3) {
        this.$router.push({ path: "/lbList", query: { sid: 13, lid: 75 } });
      }
    },

    //动态
    getOperateList() {
      var that = this;
      exhActivityMemberLogsForHome().then((res) => {
        var list = res.Data.List;
        if (list.length <= 16) {
          that.operateList[0] = list;
          that.operateList[1] = [];
        } else {
          var half = Math.ceil(list.length / 2);
          var firstHalf = list.splice(0, half);
          var secondHalf = list.splice(-half);
          that.operateList[0] = firstHalf;
          that.operateList[1] = secondHalf;
        }
      });
    },

    //品牌互动
    getExhibitionBrandRecommendList() {
      var that = this;
      exhibitionBrandRecommendList().then((res) => {
        var list = res.Data;
        list.forEach((item, index) => {
          item.ProductList.forEach((item1, index1) => {
            item1.Photos = item1.Photos.split(";");
          });
        });
        that.list = list.slice(0, 2);
        that.allList = list;
      });
    },

    // 展开更多
    showMoreHandle() {
      this.list = this.allList;
      this.isAll = 1;
    },

    //收起部分
    closeMoreHandle() {
      this.list = this.allList.slice(0, 2);
      this.isAll = 0;
      window.scrollTo(0, 2100);
    },

    //品牌新品展示跳转
    toTab(n) {
      this.$router.push({ path: "/newBrands", query: { type: n } });
    },

    //获取展馆列表
    getExhibitionList() {
      exhibitionList({ IsOrder: 0 }).then((res) => {
        this.exhibitionList = res.Data.List;
      });
    },

    //跳转展馆
    toShowRoom(hallNo) {
      this.$router.push({ path: "/expoExhibitor", query: { hallNo: hallNo } });
    },

    //tab切换
    tabHandle(idx) {
      this.bIndex = idx;
      this.scrollLeft = 0;
      this.pageIndex = 1;
      this.getLiveExhibitionCompanyList();
    },

    //参展品牌展示
    getLiveExhibitionCompanyList() {
      var that = this;
      var data = {
        HallNos: that.brandClassify[that.bIndex].Arr,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
      };
      liveExhibitionCompanyList(data).then((res) => {
        var list = [[], []];
        that.total = res.Data.Total;
        res.Data.List.forEach(function (item, index) {
          if (index % 2 == 1) {
            list[1].push(item);
          } else {
            list[0].push(item);
          }
        });
        if (that.pageIndex == 1) {
          that.brandList = list;
        } else {
          var first = that.brandList[0].concat(list[0]);
          var second = that.brandList[1].concat(list[1]);
          that.brandList = [first, second];
        }
        this.loading = false;
      });
    },

    //判断滚动条位置
    toScrolltolower() {
      const scrollDiv = document.getElementById("oneBox");
      var len = this.brandList[0].length + this.brandList[1].length;
      var scrollLeft = scrollDiv.scrollLeft;
      var width = this.pageIndex * 10 * 100 + this.pageIndex * 10;
      if (len < this.total) {
        if (scrollLeft > width - document.body.clientWidth && !this.loading) {
          this.pageIndex += 1;
          this.loading = true;
          this.getLiveExhibitionCompanyList();
        }
      }
    },

    //跳转展厅
    toStoreIndex(mid) {
      this.$router.push({ path: "/storeShow", query: { mid: mid } });
    },

    //推荐位
    getMobileAdverts() {
      var that = this;
      mobileAdverts({ Type: 342 }).then((res) => {
        that.imgList = res.Data.List;
      });
    },
  },

  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href = "https://www.alighting.com/Views/2022onlineexhibition/index.html";
    } else {
      this.getOperateList();
      this.getExhibitionBrandRecommendList();
      this.getExhibitionList();
      this.getLiveExhibitionCompanyList();
      this.getMobileAdverts();
      const scrollDiv = document.getElementById("oneBox");
      if (scrollDiv) {
        scrollDiv.addEventListener("touchmove", this.toScrolltolower, false);
      }
    }
  },
};
</script>
<style scoped src="../../../static/css/onlineExhibitionTopics.css">
</style>
